import { createContext, useContext } from 'react';

interface TranslationContextProps {
    personalizedContentMap: {
        original: null;
        translated: null;
    };
    showTranslatedContent: boolean;
    isInitialized: boolean;
    setOriginalContent: (data: any) => void;
    onTranslationToggle: (data?: any) => void;
}

/** @type {React.Context<TranslationContextData | undefined>} */
export const TranslationContext = createContext<TranslationContextProps>({
    personalizedContentMap: {
        original: null,
        translated: null,
    },
    showTranslatedContent: false,
    isInitialized: false,
    setOriginalContent: () => null,
    onTranslationToggle: () => null,
});

/** @type {() => TranslationContextData} */
export const useTranslationContext = () => useContext(TranslationContext);

/** @type {React.FC<{value: TranslationContextProps}>} */
export const TranslationContextProvider = TranslationContext.Provider;
